import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=29c4feea&"
import script from "./ExtendedTables.vue?vue&type=script&lang=js&"
export * from "./ExtendedTables.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExtendedTables.vue"
export default component.exports